import React from "react";
import { Box, Button, Typography, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SessionExpiredPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        p: 3,
      }}
    >
      <Alert severity="warning" sx={{ mb: 3, maxWidth: 500 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Session Expired
        </Typography>
        <Typography variant="body2">
          You have been logged out due to inactivity.
        </Typography>
      </Alert>

      <Button
        variant="contained"
        size="large"
        onClick={() => navigate("/About/AdminLogin")}
        sx={{ mt: 2 }}
      >
        Click Here to Log Back In
      </Button>
    </Box>
  );
};

const module = {
  routeProps: {
    path: "SessionExpired",
    component: SessionExpiredPage,
  },
  name: "Session Expired",
  label: "Session Expired",
  title: "Session Expired",
  showOnMenu: false,
};

export default module;
